import { LanguageCodes } from "../types";

// Los labels del framework se escriben en sus tres idiomas; el proyecto puede
// configurar un subconjunto (LanguageCodes) y el lookup solo usa esos.
type Translations = Record<LanguageCodes, string> &
  Partial<Record<"es" | "en" | "pt", string>>;

function langGetter(t: Translations): PropertyDescriptor {
  return {
    get(this: { language: LanguageCodes }) {
      return t[this.language];
    },
    enumerable: true,
    configurable: true,
  };
}

declare module "./LangStore" {
  interface LangStore {
    // Monitor labels
    monitorBreadcrumbTrail: string;
    monitorCurrentTrail: string;
    monitorStackDetails: string;
    monitorTotalFrames: string;
    monitorActiveFrame: string;
    monitorFrameId: string;
    monitorPathname: string;
    monitorFrameType: string;
    monitorCreatedAt: string;
    monitorLastAccessed: string;
    monitorStoreCount: string;
    monitorStoreType: string;
    monitorStatus: string;
    monitorTimestamp: string;
    monitorEvent: string;
    monitorType: string;
    monitorOperation: string;
    monitorDuration: string;
    monitorPresentation: string;
    monitorMetric: string;
    monitorValue: string;
    monitorRating: string;
    monitorThreshold: string;
    monitorPerformanceScore: string;
    monitorUsed: string;
    monitorTotal: string;
    monitorLimit: string;
    monitorGoodThreshold: string;
    monitorPoorThreshold: string;
    monitorNeedsImprovement: string;
    monitorINP: string;
    monitorInteractionToNextPaint: string;
    monitorCachedBreadcrumbLabel: string;
    monitorLastSave: string;
    monitorNavigation: string;
    monitorStores: string;
    monitorActivity: string;
    monitorPerformance: string;
    monitorNetwork: string;
    monitorOverview: string;
    monitorConnectionStatus: string;
    monitorCurrentUser: string;
    monitorNavigationState: string;
    monitorRouterPath: string;
    monitorBreadcrumbCount: string;
    monitorStackIsEmpty: string;
    monitorNoStoreFoundForCurrentPathname: string;
    monitorNoFrameFound: string;
    monitorNoActiveFrame: string;
    monitorNoBreadcrumbs: string;
    monitorNoActivity: string;
    monitorNoMetrics: string;
    monitorNoNetworkRequests: string;
    monitorErrorLoadingData: string;
    monitorInvalidFrameData: string;
    monitorStoreNotInitialized: string;
    monitorShowingDynamicStores: string;
    monitorStaticStoresNotIncluded: string;
    monitorChecking: string;
    monitorBrowserConnection: string;
    monitorSSEStatus: string;
    monitorReconnectAttempts: string;
    monitorNetworkType: string;
    monitorDownlink: string;
    monitorRTT: string;
    monitorDataSaverMode: string;
    monitorServiceWorker: string;
    monitorUpdateAvailable: string;
    monitorSSEConnection: string;
    monitorRealTimeConnectionDesc: string;
    monitorConnection: string;
    monitorNetworkLabel: string;
    monitorActiveOperations: string;
    monitorQueries: string;
    monitorMutations: string;
    monitorStorage: string;
    monitorActiveStores: string;
    monitorNetworkSpeed: string;
    monitorDataSaverOn: string;
    monitorSWNotSupported: string;
    monitorSWNotRegistered: string;
    monitorSWActivated: string;
    monitorSWError: string;
    monitorSWActivatedState: string;
    monitorSWNotSupportedState: string;
    monitorSWNotRegisteredState: string;
    monitorSWErrorState: string;
    monitorSWUnknownState: string;
    monitorBrowserSyncActive: string;
    monitorBrowserSyncInactive: string;
    monitorSSEConnectedStatus: string;
    monitorSSEDisconnectedStatus: string;
    monitorCopyDebugInfo: string;
    monitorInspectIndexedDB: string;
    monitorClearStack: string;
    monitorRefresh: string;
    monitorExport: string;
    monitorClose: string;
    monitorOnline: string;
    monitorOffline: string;
    monitorActive: string;
    monitorInactive: string;
    monitorPending: string;
    monitorCompleted: string;
    monitorFailed: string;
    monitorGood: string;
    monitorPoor: string;
    monitorSlow: string;
    monitorFast: string;
    monitorPage: string;
    monitorModal: string;
    monitorDrawer: string;
    monitorOverlay: string;
    monitorList: string;
    monitorView: string;
    monitorUpdate: string;
    monitorCreate: string;
    monitorCustom: string;
    monitorStart: string;
    monitorEnd: string;
    monitorQuery: string;
    monitorMutation: string;
    monitorNA: string;
    monitorNone: string;
    monitorUnknown: string;
    monitorNever: string;
    monitorJustNow: string;
    monitorLCP: string;
    monitorFID: string;
    monitorCLS: string;
    monitorTTFB: string;
    monitorFCP: string;
    monitorLargestContentfulPaint: string;
    monitorFirstInputDelay: string;
    monitorCumulativeLayoutShift: string;
    monitorTimeToFirstByte: string;
    monitorFirstContentfulPaint: string;
    monitorConnectionSpeed: string;
    monitorLatency: string;
    monitorBandwidth: string;
    monitorRequestCount: string;
    monitorErrorCount: string;
    monitorCacheHitRate: string;
    monitorTotalDataTransferred: string;
    monitorAverageResponseTime: string;
    monitorMemoryUsage: string;
    monitorMs: string;
    monitorMbps: string;
    monitorMb: string;
    monitorPercentUsed: string;
    monitorDash: string;
    monitorInicio: string;
    monitorNull: string;
    monitorItemsCount: string;
    monitorThresholdFormat: string;
    monitorIndex: string;
    monitorLabel: string;
    monitorTime: string;
    monitorAction: string;
    monitorData: string;
    monitorStackIsEmptyMessage: string;
    monitorCurrentPageInfo: string;
    monitorPersistence: string;
    monitorPersistenceDebugInfo: string;
    monitorEventLog: string;
    monitorActions: string;
    monitorRawIndexedDBData: string;
    monitorNotSet: string;
    monitorEventsLogged: string;
    monitorNoEventsLoggedYet: string;
    monitorHideDebugDetails: string;
    monitorShowDebugDetails: string;
    monitorTypeLabel: string;
    monitorLastSaveDebug: string;
    monitorLastLoadDebug: string;
    monitorEventCount: string;
    monitorUsingIndexedDB: string;
    monitorUsingSessionStorage: string;
    monitorReloadFromDB: string;
    monitorSystemMonitor: string;
    monitorCopyJson: string;
    monitorExportJson: string;
    monitorBreadcrumbs: string;
    monitorCache: string;
    monitorCacheEntity: string;
    monitorCacheRows: string;
    monitorCacheSize: string;
    monitorCacheCachedAt: string;
    monitorCacheTotalRows: string;
    monitorCacheTotalSize: string;
    monitorCacheInvalidateAll: string;
    monitorSnapshotCopied: string;
    monitorCopyFailed: string;
    monitorSnapshotDownloaded: string;
    monitorConnected: string;
    monitorDisconnected: string;
    monitorConnecting: string;
    // Bot Monitor labels
    botMonitorProgressLabel: string;
    botMonitorPhaseLabel: string;
    botMonitorStepsLabel: string;
    botMonitorNoPhases: string;
    botMonitorNoSteps: string;
    botMonitorNoErrors: string;
    botMonitorRequiredLabel: string;
    botMonitorRequiresInterventionTooltip: string;
    botMonitorRecoverableLabel: string;
    // Satellite labels
    satelliteAuthorize: string;
    satelliteSuspend: string;
    satelliteReactivate: string;
    satelliteRevoke: string;
    satelliteEnable: string;
    satelliteDisable: string;
    satelliteRotateToken: string;
    satelliteDisconnect: string;
    satelliteSuspendTitle: string;
    satelliteSuspendDescription: string;
    satelliteRevokeTitle: string;
    satelliteRevokeDescription: string;
    satelliteTokenTitle: string;
    satelliteReasonLabel: string;
    satelliteCopyToken: string;
    satelliteAuthorized: string;
    satelliteSuspended: string;
    satelliteReactivated: string;
    satelliteRevoked: string;
    satelliteEnabled: string;
    satelliteDisabled: string;
    satelliteDisconnected: string;
    satelliteAuthorizeError: string;
    satelliteSuspendError: string;
    satelliteReactivateError: string;
    satelliteRevokeError: string;
    satelliteToggleError: string;
    satelliteRotateTokenError: string;
    satelliteDisconnectError: string;
  }
}

export function monitorLabelDescriptors(): PropertyDescriptorMap {
  return {
    // Monitor labels
    monitorBreadcrumbTrail: langGetter({
      es: "Trail de Breadcrumbs",
      en: "Breadcrumb Trail",
      pt: "Trail de Breadcrumbs",
    }),
    monitorCurrentTrail: langGetter({
      es: "Trail Actual",
      en: "Current Trail",
      pt: "Trail Atual",
    }),
    monitorStackDetails: langGetter({
      es: "Detalles del Stack",
      en: "Stack Details",
      pt: "Detalhes da Stack",
    }),
    monitorTotalFrames: langGetter({
      es: "Total de Frames",
      en: "Total Frames",
      pt: "Total de Frames",
    }),
    monitorActiveFrame: langGetter({
      es: "Frame Activo",
      en: "Active Frame",
      pt: "Frame Ativo",
    }),
    monitorFrameId: langGetter({
      es: "Frame ID",
      en: "Frame ID",
      pt: "Frame ID",
    }),
    monitorPathname: langGetter({
      es: "Pathname",
      en: "Pathname",
      pt: "Pathname",
    }),
    monitorFrameType: langGetter({ es: "Tipo", en: "Type", pt: "Tipo" }),
    monitorCreatedAt: langGetter({ es: "Creado", en: "Created", pt: "Criado" }),
    monitorLastAccessed: langGetter({
      es: "Último Acceso",
      en: "Last Accessed",
      pt: "Último Acesso",
    }),
    monitorStoreCount: langGetter({ es: "Stores", en: "Stores", pt: "Stores" }),
    monitorStoreType: langGetter({
      es: "Tipo de Store",
      en: "Store Type",
      pt: "Tipo de Store",
    }),
    monitorStatus: langGetter({ es: "Estado", en: "Status", pt: "Estado" }),
    monitorTimestamp: langGetter({
      es: "Marca de Tiempo",
      en: "Timestamp",
      pt: "Marca de Tempo",
    }),
    monitorEvent: langGetter({ es: "Evento", en: "Event", pt: "Evento" }),
    monitorType: langGetter({ es: "Tipo", en: "Type", pt: "Tipo" }),
    monitorOperation: langGetter({
      es: "Operación",
      en: "Operation",
      pt: "Operação",
    }),
    monitorDuration: langGetter({
      es: "Duración",
      en: "Duration",
      pt: "Duração",
    }),
    monitorPresentation: langGetter({
      es: "Presentación",
      en: "Presentation",
      pt: "Apresentação",
    }),
    monitorMetric: langGetter({ es: "Métrica", en: "Metric", pt: "Métrica" }),
    monitorValue: langGetter({ es: "Valor", en: "Value", pt: "Valor" }),
    monitorRating: langGetter({
      es: "Calificación",
      en: "Rating",
      pt: "Avaliação",
    }),
    monitorThreshold: langGetter({
      es: "Umbral",
      en: "Threshold",
      pt: "Limite",
    }),
    monitorPerformanceScore: langGetter({
      es: "Puntuación de Performance",
      en: "Performance Score",
      pt: "Pontuação de Performance",
    }),
    monitorUsed: langGetter({ es: "Usado", en: "Used", pt: "Usado" }),
    monitorTotal: langGetter({ es: "Total", en: "Total", pt: "Total" }),
    monitorLimit: langGetter({ es: "Límite", en: "Limit", pt: "Limite" }),
    monitorGoodThreshold: langGetter({
      es: "Bueno: <{value}",
      en: "Good: <{value}",
      pt: "Bom: <{value}",
    }),
    monitorPoorThreshold: langGetter({
      es: "Pobre: >{value}",
      en: "Poor: >{value}",
      pt: "Ruim: >{value}",
    }),
    monitorNeedsImprovement: langGetter({
      es: "NECESITA MEJORA",
      en: "NEEDS-IMPROVEMENT",
      pt: "PRECISA MELHORAR",
    }),
    monitorINP: langGetter({ es: "INP", en: "INP", pt: "INP" }),
    monitorInteractionToNextPaint: langGetter({
      es: "Interaction to Next Paint",
      en: "Interaction to Next Paint",
      pt: "Interaction to Next Paint",
    }),
    monitorCachedBreadcrumbLabel: langGetter({
      es: "Label Breadcrumb",
      en: "Breadcrumb Label",
      pt: "Label Breadcrumb",
    }),
    monitorLastSave: langGetter({
      es: "Último Guardado",
      en: "Last Save",
      pt: "Último Guardado",
    }),
    monitorNavigation: langGetter({
      es: "Navegación",
      en: "Navigation",
      pt: "Navegação",
    }),
    monitorStores: langGetter({ es: "Stores", en: "Stores", pt: "Stores" }),
    monitorActivity: langGetter({
      es: "Actividad",
      en: "Activity",
      pt: "Atividade",
    }),
    monitorPerformance: langGetter({
      es: "Performance",
      en: "Performance",
      pt: "Performance",
    }),
    monitorNetwork: langGetter({ es: "Red", en: "Network", pt: "Rede" }),
    monitorOverview: langGetter({
      es: "Resumen",
      en: "Overview",
      pt: "Resumo",
    }),
    monitorConnectionStatus: langGetter({
      es: "Estado de Conexión",
      en: "Connection Status",
      pt: "Estado de Conexão",
    }),
    monitorCurrentUser: langGetter({
      es: "Usuario Actual",
      en: "Current User",
      pt: "Usuário Atual",
    }),
    monitorNavigationState: langGetter({
      es: "Estado de Navegación",
      en: "Navigation State",
      pt: "Estado de Navegação",
    }),
    monitorRouterPath: langGetter({
      es: "Router Path",
      en: "Router Path",
      pt: "Router Path",
    }),
    monitorBreadcrumbCount: langGetter({
      es: "Breadcrumbs",
      en: "Breadcrumbs",
      pt: "Breadcrumbs",
    }),
    monitorStackIsEmpty: langGetter({
      es: "El stack de navegación está vacío",
      en: "Navigation stack is empty",
      pt: "A stack de navegação está vazia",
    }),
    monitorNoStoreFoundForCurrentPathname: langGetter({
      es: "No se encontró store para el pathname actual",
      en: "No store found for current pathname",
      pt: "Nenhuma store encontrada para o pathname atual",
    }),
    monitorNoFrameFound: langGetter({
      es: "Frame no encontrado",
      en: "Frame not found",
      pt: "Frame não encontrado",
    }),
    monitorNoActiveFrame: langGetter({
      es: "Sin frame activo",
      en: "No active frame",
      pt: "Sem frame ativo",
    }),
    monitorNoBreadcrumbs: langGetter({
      es: "Sin breadcrumbs",
      en: "No breadcrumbs",
      pt: "Sem breadcrumbs",
    }),
    monitorNoActivity: langGetter({
      es: "Sin actividad reciente",
      en: "No recent activity",
      pt: "Sem atividade recente",
    }),
    monitorNoMetrics: langGetter({
      es: "Sin métricas disponibles",
      en: "No metrics available",
      pt: "Sem métricas disponíveis",
    }),
    monitorNoNetworkRequests: langGetter({
      es: "Sin peticiones de red",
      en: "No network requests",
      pt: "Sem requisições de rede",
    }),
    monitorErrorLoadingData: langGetter({
      es: "Error al cargar datos",
      en: "Error loading data",
      pt: "Erro ao carregar dados",
    }),
    monitorInvalidFrameData: langGetter({
      es: "Datos de frame inválidos",
      en: "Invalid frame data",
      pt: "Dados de frame inválidos",
    }),
    monitorStoreNotInitialized: langGetter({
      es: "Store no inicializado",
      en: "Store not initialized",
      pt: "Store não inicializado",
    }),
    monitorShowingDynamicStores: langGetter({
      es: "Mostrando {count} stores dinámicos activos gestionados por StoreRegistry.",
      en: "Showing {count} active dynamic stores managed by StoreRegistry.",
      pt: "Mostrando {count} stores dinâmicos ativos gerenciados por StoreRegistry.",
    }),
    monitorStaticStoresNotIncluded: langGetter({
      es: "Los stores estáticos (AuthStore, LangStore, etc.) no están incluidos.",
      en: "Static stores (AuthStore, LangStore, etc.) are not included.",
      pt: "Stores estáticos (AuthStore, LangStore, etc.) não estão incluídos.",
    }),
    monitorChecking: langGetter({
      es: "verificando...",
      en: "checking...",
      pt: "verificando...",
    }),
    monitorBrowserConnection: langGetter({
      es: "Conexión del Navegador",
      en: "Browser Connection",
      pt: "Conexão do Navegador",
    }),
    monitorSSEStatus: langGetter({
      es: "Estado SSE",
      en: "SSE Status",
      pt: "Estado SSE",
    }),
    monitorReconnectAttempts: langGetter({
      es: "Intentos de Reconexión",
      en: "Reconnect Attempts",
      pt: "Tentativas de Reconexão",
    }),
    monitorNetworkType: langGetter({
      es: "Tipo de Red",
      en: "Network Type",
      pt: "Tipo de Rede",
    }),
    monitorDownlink: langGetter({
      es: "Bajada",
      en: "Downlink",
      pt: "Download",
    }),
    monitorRTT: langGetter({ es: "RTT", en: "RTT", pt: "RTT" }),
    monitorDataSaverMode: langGetter({
      es: "Modo Ahorro de Datos",
      en: "Data Saver Mode",
      pt: "Modo Economia de Dados",
    }),
    monitorServiceWorker: langGetter({
      es: "Service Worker",
      en: "Service Worker",
      pt: "Service Worker",
    }),
    monitorUpdateAvailable: langGetter({
      es: "Actualización Disponible",
      en: "Update Available",
      pt: "Atualização Disponível",
    }),
    monitorSSEConnection: langGetter({
      es: "Conexión SSE",
      en: "SSE Connection",
      pt: "Conexão SSE",
    }),
    monitorRealTimeConnectionDesc: langGetter({
      es: "Conexión en tiempo real al servidor para eventos y actualizaciones del sistema",
      en: "Real-time connection to server for system events and updates",
      pt: "Conexão em tempo real com o servidor para eventos e atualizações do sistema",
    }),
    monitorConnection: langGetter({
      es: "Conexión",
      en: "Connection",
      pt: "Conexão",
    }),
    monitorNetworkLabel: langGetter({ es: "Red", en: "Network", pt: "Rede" }),
    monitorActiveOperations: langGetter({
      es: "Operaciones Activas",
      en: "Active Operations",
      pt: "Operações Ativas",
    }),
    monitorQueries: langGetter({
      es: "Consultas",
      en: "Queries",
      pt: "Consultas",
    }),
    monitorMutations: langGetter({
      es: "Mutaciones",
      en: "Mutations",
      pt: "Mutações",
    }),
    monitorStorage: langGetter({
      es: "Almacenamiento",
      en: "Storage",
      pt: "Armazenamento",
    }),
    monitorActiveStores: langGetter({
      es: "Stores Activos",
      en: "Active Stores",
      pt: "Stores Ativos",
    }),
    monitorNetworkSpeed: langGetter({
      es: "Velocidad de Red",
      en: "Network Speed",
      pt: "Velocidade de Rede",
    }),
    monitorDataSaverOn: langGetter({
      es: "Ahorro de Datos ACTIVO",
      en: "Data Saver ON",
      pt: "Economia de Dados ATIVA",
    }),
    monitorSWNotSupported: langGetter({
      es: "Service Worker no soportado en este navegador",
      en: "Service Worker not supported in this browser",
      pt: "Service Worker não suportado neste navegador",
    }),
    monitorSWNotRegistered: langGetter({
      es: "No hay Service Worker registrado",
      en: "No Service Worker registered",
      pt: "Nenhum Service Worker registrado",
    }),
    monitorSWActivated: langGetter({
      es: "Service Worker está activo y controlando la página",
      en: "Service Worker is active and controlling the page",
      pt: "Service Worker está ativo e controlando a página",
    }),
    monitorSWError: langGetter({
      es: "Error al verificar el estado del Service Worker",
      en: "Error checking Service Worker status",
      pt: "Erro ao verificar o estado do Service Worker",
    }),
    monitorSWActivatedState: langGetter({
      es: "activated",
      en: "activated",
      pt: "activated",
    }),
    monitorSWNotSupportedState: langGetter({
      es: "not_supported",
      en: "not_supported",
      pt: "not_supported",
    }),
    monitorSWNotRegisteredState: langGetter({
      es: "not_registered",
      en: "not_registered",
      pt: "not_registered",
    }),
    monitorSWErrorState: langGetter({ es: "error", en: "error", pt: "error" }),
    monitorSWUnknownState: langGetter({
      es: "unknown",
      en: "unknown",
      pt: "unknown",
    }),
    monitorBrowserSyncActive: langGetter({
      es: "Sincronización browser activa",
      en: "Browser sync active",
      pt: "Sincronização browser ativa",
    }),
    monitorBrowserSyncInactive: langGetter({
      es: "Sincronización browser inactiva",
      en: "Browser sync inactive",
      pt: "Sincronização browser inativa",
    }),
    monitorSSEConnectedStatus: langGetter({
      es: "SSE conectado",
      en: "SSE connected",
      pt: "SSE conectado",
    }),
    monitorSSEDisconnectedStatus: langGetter({
      es: "SSE desconectado",
      en: "SSE disconnected",
      pt: "SSE desconectado",
    }),
    monitorCopyDebugInfo: langGetter({
      es: "Copiar Info Debug",
      en: "Copy Debug Info",
      pt: "Copiar Info Debug",
    }),
    monitorInspectIndexedDB: langGetter({
      es: "Inspeccionar IndexedDB",
      en: "Inspect IndexedDB",
      pt: "Inspecionar IndexedDB",
    }),
    monitorClearStack: langGetter({
      es: "Limpiar Stack",
      en: "Clear Stack",
      pt: "Limpar Stack",
    }),
    monitorRefresh: langGetter({
      es: "Refrescar",
      en: "Refresh",
      pt: "Atualizar",
    }),
    monitorExport: langGetter({ es: "Exportar", en: "Export", pt: "Exportar" }),
    monitorClose: langGetter({ es: "Cerrar", en: "Close", pt: "Fechar" }),
    monitorOnline: langGetter({ es: "En línea", en: "Online", pt: "Online" }),
    monitorOffline: langGetter({
      es: "Desconectado",
      en: "Offline",
      pt: "Desconectado",
    }),
    monitorActive: langGetter({ es: "Activo", en: "Active", pt: "Ativo" }),
    monitorInactive: langGetter({
      es: "Inactivo",
      en: "Inactive",
      pt: "Inativo",
    }),
    monitorPending: langGetter({
      es: "Pendiente",
      en: "Pending",
      pt: "Pendente",
    }),
    monitorCompleted: langGetter({
      es: "Completado",
      en: "Completed",
      pt: "Completado",
    }),
    monitorFailed: langGetter({ es: "Fallido", en: "Failed", pt: "Falhado" }),
    monitorGood: langGetter({ es: "Bueno", en: "Good", pt: "Bom" }),
    monitorPoor: langGetter({ es: "Pobre", en: "Poor", pt: "Ruim" }),
    monitorSlow: langGetter({ es: "Lento", en: "Slow", pt: "Lento" }),
    monitorFast: langGetter({ es: "Rápido", en: "Fast", pt: "Rápido" }),
    monitorPage: langGetter({ es: "Página", en: "Page", pt: "Página" }),
    monitorModal: langGetter({ es: "Modal", en: "Modal", pt: "Modal" }),
    monitorDrawer: langGetter({ es: "Drawer", en: "Drawer", pt: "Drawer" }),
    monitorOverlay: langGetter({ es: "Overlay", en: "Overlay", pt: "Overlay" }),
    monitorList: langGetter({ es: "Lista", en: "List", pt: "Lista" }),
    monitorView: langGetter({ es: "Vista", en: "View", pt: "Visualização" }),
    monitorUpdate: langGetter({
      es: "Actualizar",
      en: "Update",
      pt: "Atualizar",
    }),
    monitorCreate: langGetter({ es: "Crear", en: "Create", pt: "Criar" }),
    monitorCustom: langGetter({
      es: "Personalizado",
      en: "Custom",
      pt: "Personalizado",
    }),
    monitorStart: langGetter({ es: "INICIO", en: "START", pt: "INÍCIO" }),
    monitorEnd: langGetter({ es: "FIN", en: "END", pt: "FIM" }),
    monitorQuery: langGetter({ es: "consulta", en: "query", pt: "consulta" }),
    monitorMutation: langGetter({
      es: "mutación",
      en: "mutation",
      pt: "mutação",
    }),
    monitorNA: langGetter({ es: "N/A", en: "N/A", pt: "N/A" }),
    monitorNone: langGetter({ es: "Ninguno", en: "None", pt: "Nenhum" }),
    monitorUnknown: langGetter({
      es: "Desconocido",
      en: "Unknown",
      pt: "Desconhecido",
    }),
    monitorNever: langGetter({ es: "Nunca", en: "Never", pt: "Nunca" }),
    monitorJustNow: langGetter({
      es: "Justo ahora",
      en: "Just now",
      pt: "Agora mesmo",
    }),
    monitorLCP: langGetter({ es: "LCP", en: "LCP", pt: "LCP" }),
    monitorFID: langGetter({ es: "FID", en: "FID", pt: "FID" }),
    monitorCLS: langGetter({ es: "CLS", en: "CLS", pt: "CLS" }),
    monitorTTFB: langGetter({ es: "TTFB", en: "TTFB", pt: "TTFB" }),
    monitorFCP: langGetter({ es: "FCP", en: "FCP", pt: "FCP" }),
    monitorLargestContentfulPaint: langGetter({
      es: "Largest Contentful Paint",
      en: "Largest Contentful Paint",
      pt: "Largest Contentful Paint",
    }),
    monitorFirstInputDelay: langGetter({
      es: "First Input Delay",
      en: "First Input Delay",
      pt: "First Input Delay",
    }),
    monitorCumulativeLayoutShift: langGetter({
      es: "Cumulative Layout Shift",
      en: "Cumulative Layout Shift",
      pt: "Cumulative Layout Shift",
    }),
    monitorTimeToFirstByte: langGetter({
      es: "Time to First Byte",
      en: "Time to First Byte",
      pt: "Time to First Byte",
    }),
    monitorFirstContentfulPaint: langGetter({
      es: "First Contentful Paint",
      en: "First Contentful Paint",
      pt: "First Contentful Paint",
    }),
    monitorConnectionSpeed: langGetter({
      es: "Velocidad de Conexión",
      en: "Connection Speed",
      pt: "Velocidade de Conexão",
    }),
    monitorLatency: langGetter({
      es: "Latencia",
      en: "Latency",
      pt: "Latência",
    }),
    monitorBandwidth: langGetter({
      es: "Ancho de Banda",
      en: "Bandwidth",
      pt: "Largura de Banda",
    }),
    monitorRequestCount: langGetter({
      es: "Total de Requests",
      en: "Request Count",
      pt: "Total de Requisições",
    }),
    monitorErrorCount: langGetter({
      es: "Total de Errores",
      en: "Error Count",
      pt: "Total de Erros",
    }),
    monitorCacheHitRate: langGetter({
      es: "Cache Hit Rate",
      en: "Cache Hit Rate",
      pt: "Taxa de Acerto de Cache",
    }),
    monitorTotalDataTransferred: langGetter({
      es: "Datos Transferidos",
      en: "Data Transferred",
      pt: "Dados Transferidos",
    }),
    monitorAverageResponseTime: langGetter({
      es: "Tiempo de Respuesta Promedio",
      en: "Average Response Time",
      pt: "Tempo de Resposta Médio",
    }),
    monitorMemoryUsage: langGetter({
      es: "Uso de Memoria",
      en: "Memory Usage",
      pt: "Uso de Memória",
    }),
    monitorMs: langGetter({ es: "ms", en: "ms", pt: "ms" }),
    monitorMbps: langGetter({ es: "Mbps", en: "Mbps", pt: "Mbps" }),
    monitorMb: langGetter({ es: "MB", en: "MB", pt: "MB" }),
    monitorPercentUsed: langGetter({
      es: "% usado",
      en: "% used",
      pt: "% usado",
    }),
    monitorDash: langGetter({ es: "-", en: "-", pt: "-" }),
    monitorInicio: langGetter({ es: "Inicio", en: "Home", pt: "Início" }),
    monitorNull: langGetter({ es: "null", en: "null", pt: "null" }),
    monitorItemsCount: langGetter({
      es: "{count} items",
      en: "{count} items",
      pt: "{count} itens",
    }),
    monitorThresholdFormat: langGetter({
      es: "{current}/{max}",
      en: "{current}/{max}",
      pt: "{current}/{max}",
    }),
    monitorIndex: langGetter({ es: "Índice", en: "Index", pt: "Índice" }),
    monitorLabel: langGetter({ es: "Etiqueta", en: "Label", pt: "Etiqueta" }),
    monitorTime: langGetter({ es: "Tiempo", en: "Time", pt: "Tempo" }),
    monitorAction: langGetter({ es: "Acción", en: "Action", pt: "Ação" }),
    monitorData: langGetter({ es: "Datos", en: "Data", pt: "Dados" }),
    monitorStackIsEmptyMessage: langGetter({
      es: "El stack está vacío",
      en: "Stack is empty",
      pt: "A stack está vazia",
    }),
    monitorCurrentPageInfo: langGetter({
      es: "Info de Página Actual",
      en: "Current Page Info",
      pt: "Info da Página Atual",
    }),
    monitorPersistence: langGetter({
      es: "Persistencia",
      en: "Persistence",
      pt: "Persistência",
    }),
    monitorPersistenceDebugInfo: langGetter({
      es: "Info de Debug de Persistencia",
      en: "Persistence Debug Info",
      pt: "Info de Debug de Persistência",
    }),
    monitorEventLog: langGetter({
      es: "Log de Eventos (últimos {count})",
      en: "Event Log (last {count})",
      pt: "Log de Eventos (últimos {count})",
    }),
    monitorActions: langGetter({ es: "Acciones", en: "Actions", pt: "Ações" }),
    monitorRawIndexedDBData: langGetter({
      es: "Datos Crudos de IndexedDB:",
      en: "Raw IndexedDB Data:",
      pt: "Dados Brutos de IndexedDB:",
    }),
    monitorNotSet: langGetter({
      es: "(no establecido)",
      en: "(not set)",
      pt: "(não definido)",
    }),
    monitorEventsLogged: langGetter({
      es: "{count} eventos registrados",
      en: "{count} events logged",
      pt: "{count} eventos registrados",
    }),
    monitorNoEventsLoggedYet: langGetter({
      es: "Aún no hay eventos registrados",
      en: "No events logged yet",
      pt: "Ainda não há eventos registrados",
    }),
    monitorHideDebugDetails: langGetter({
      es: "Ocultar Detalles de Debug",
      en: "Hide Debug Details",
      pt: "Ocultar Detalhes de Debug",
    }),
    monitorShowDebugDetails: langGetter({
      es: "Mostrar Detalles de Debug",
      en: "Show Debug Details",
      pt: "Mostrar Detalhes de Debug",
    }),
    monitorTypeLabel: langGetter({ es: "Tipo:", en: "Type:", pt: "Tipo:" }),
    monitorLastSaveDebug: langGetter({
      es: "Último GUARDADO:",
      en: "Last SAVE:",
      pt: "Último SALVAMENTO:",
    }),
    monitorLastLoadDebug: langGetter({
      es: "Última CARGA:",
      en: "Last LOAD:",
      pt: "Última CARGA:",
    }),
    monitorEventCount: langGetter({
      es: "Cantidad de Eventos:",
      en: "Event Count:",
      pt: "Contagem de Eventos:",
    }),
    monitorUsingIndexedDB: langGetter({
      es: "Usando IndexedDB para persistencia (deshabilitar con localStorage.setItem('feature.disable-indexeddb', 'true'))",
      en: "Using IndexedDB for persistence (disable with localStorage.setItem('feature.disable-indexeddb', 'true'))",
      pt: "Usando IndexedDB para persistência (desabilitar com localStorage.setItem('feature.disable-indexeddb', 'true'))",
    }),
    monitorUsingSessionStorage: langGetter({
      es: "Usando SessionStorage para persistencia",
      en: "Using SessionStorage for persistence",
      pt: "Usando SessionStorage para persistência",
    }),
    monitorReloadFromDB: langGetter({
      es: "Recargar desde DB",
      en: "Reload from DB",
      pt: "Recarregar do DB",
    }),
    monitorSystemMonitor: langGetter({
      es: "Monitor del Sistema",
      en: "System Monitor",
      pt: "Monitor do Sistema",
    }),
    monitorCopyJson: langGetter({
      es: "Copiar JSON",
      en: "Copy JSON",
      pt: "Copiar JSON",
    }),
    monitorExportJson: langGetter({
      es: "Exportar JSON",
      en: "Export JSON",
      pt: "Exportar JSON",
    }),
    monitorBreadcrumbs: langGetter({
      es: "Breadcrumbs",
      en: "Breadcrumbs",
      pt: "Breadcrumbs",
    }),
    monitorCache: langGetter({ es: "Cache", en: "Cache", pt: "Cache" }),
    monitorCacheEntity: langGetter({
      es: "Entidad",
      en: "Entity",
      pt: "Entidade",
    }),
    monitorCacheRows: langGetter({ es: "Filas", en: "Rows", pt: "Linhas" }),
    monitorCacheSize: langGetter({ es: "Tamaño", en: "Size", pt: "Tamanho" }),
    monitorCacheCachedAt: langGetter({
      es: "Cacheado",
      en: "Cached At",
      pt: "Em Cache",
    }),
    monitorCacheTotalRows: langGetter({
      es: "Total filas",
      en: "Total rows",
      pt: "Total linhas",
    }),
    monitorCacheTotalSize: langGetter({
      es: "Total tamaño",
      en: "Total size",
      pt: "Total tamanho",
    }),
    monitorCacheInvalidateAll: langGetter({
      es: "Invalidar Todo",
      en: "Invalidate All",
      pt: "Invalidar Tudo",
    }),
    monitorSnapshotCopied: langGetter({
      es: "Snapshot del sistema copiado al portapapeles",
      en: "System snapshot copied to clipboard",
      pt: "Snapshot do sistema copiado para a área de transferência",
    }),
    monitorCopyFailed: langGetter({
      es: "Error al copiar al portapapeles",
      en: "Failed to copy to clipboard",
      pt: "Falha ao copiar para a área de transferência",
    }),
    monitorSnapshotDownloaded: langGetter({
      es: "Snapshot del sistema descargado",
      en: "System snapshot downloaded",
      pt: "Snapshot do sistema baixado",
    }),
    monitorConnected: langGetter({
      es: "CONECTADO",
      en: "CONNECTED",
      pt: "CONECTADO",
    }),
    monitorDisconnected: langGetter({
      es: "DESCONECTADO",
      en: "DISCONNECTED",
      pt: "DESCONECTADO",
    }),
    monitorConnecting: langGetter({
      es: "CONECTANDO",
      en: "CONNECTING",
      pt: "CONECTANDO",
    }),
    // Bot Monitor labels
    botMonitorProgressLabel: langGetter({
      es: "Progreso",
      en: "Progress",
      pt: "Progresso",
    }),
    botMonitorPhaseLabel: langGetter({ es: "Fase", en: "Phase", pt: "Fase" }),
    botMonitorStepsLabel: langGetter({
      es: "Pasos",
      en: "Steps",
      pt: "Passos",
    }),
    botMonitorNoPhases: langGetter({
      es: "No hay fases registradas",
      en: "No phases recorded",
      pt: "Nenhuma fase registrada",
    }),
    botMonitorNoSteps: langGetter({
      es: "No hay pasos registrados",
      en: "No steps recorded",
      pt: "Nenhum passo registrado",
    }),
    botMonitorNoErrors: langGetter({
      es: "Sin errores",
      en: "No errors",
      pt: "Sem erros",
    }),
    botMonitorRequiredLabel: langGetter({
      es: "Requerida",
      en: "Required",
      pt: "Necessária",
    }),
    botMonitorRequiresInterventionTooltip: langGetter({
      es: "Requiere intervención",
      en: "Requires intervention",
      pt: "Requer intervenção",
    }),
    botMonitorRecoverableLabel: langGetter({
      es: "Recuperable",
      en: "Recoverable",
      pt: "Recuperável",
    }),
    // Satellite labels
    satelliteAuthorize: langGetter({
      es: "Autorizar",
      en: "Authorize",
      pt: "Autorizar",
    }),
    satelliteSuspend: langGetter({
      es: "Suspender",
      en: "Suspend",
      pt: "Suspender",
    }),
    satelliteReactivate: langGetter({
      es: "Reactivar",
      en: "Reactivate",
      pt: "Reativar",
    }),
    satelliteRevoke: langGetter({ es: "Revocar", en: "Revoke", pt: "Revogar" }),
    satelliteEnable: langGetter({
      es: "Habilitar",
      en: "Enable",
      pt: "Habilitar",
    }),
    satelliteDisable: langGetter({
      es: "Deshabilitar",
      en: "Disable",
      pt: "Desabilitar",
    }),
    satelliteRotateToken: langGetter({
      es: "Rotar Token",
      en: "Rotate Token",
      pt: "Rotacionar Token",
    }),
    satelliteDisconnect: langGetter({
      es: "Desconectar",
      en: "Disconnect",
      pt: "Desconectar",
    }),
    satelliteSuspendTitle: langGetter({
      es: "Suspender Satellite",
      en: "Suspend Satellite",
      pt: "Suspender Satellite",
    }),
    satelliteSuspendDescription: langGetter({
      es: "El satellite no podrá conectarse mientras esté suspendido. Motivo de la suspensión:",
      en: "The satellite will not be able to connect while suspended. Enter a reason for the suspension:",
      pt: "O satellite não poderá se conectar enquanto estiver suspenso. Insira um motivo para a suspensão:",
    }),
    satelliteRevokeTitle: langGetter({
      es: "Revocar Satellite",
      en: "Revoke Satellite",
      pt: "Revogar Satellite",
    }),
    satelliteRevokeDescription: langGetter({
      es: "Esta acción es permanente. El satellite será desconectado y no podrá volver a conectarse. Motivo:",
      en: "This action is permanent. The satellite will be disconnected and will not be able to reconnect. Enter a reason:",
      pt: "Esta ação é permanente. O satellite será desconectado e não poderá se reconectar. Insira um motivo:",
    }),
    satelliteTokenTitle: langGetter({
      es: "Nuevo Token Generado",
      en: "New Token Generated",
      pt: "Novo Token Gerado",
    }),
    satelliteReasonLabel: langGetter({
      es: "Motivo",
      en: "Reason",
      pt: "Motivo",
    }),
    satelliteCopyToken: langGetter({
      es: "Copiar token",
      en: "Copy token",
      pt: "Copiar token",
    }),
    satelliteAuthorized: langGetter({
      es: "Satellite autorizado",
      en: "Satellite authorized",
      pt: "Satellite autorizado",
    }),
    satelliteSuspended: langGetter({
      es: "Satellite suspendido",
      en: "Satellite suspended",
      pt: "Satellite suspenso",
    }),
    satelliteReactivated: langGetter({
      es: "Satellite reactivado",
      en: "Satellite reactivated",
      pt: "Satellite reativado",
    }),
    satelliteRevoked: langGetter({
      es: "Satellite revocado",
      en: "Satellite revoked",
      pt: "Satellite revogado",
    }),
    satelliteEnabled: langGetter({
      es: "Satellite habilitado",
      en: "Satellite enabled",
      pt: "Satellite habilitado",
    }),
    satelliteDisabled: langGetter({
      es: "Satellite deshabilitado",
      en: "Satellite disabled",
      pt: "Satellite desabilitado",
    }),
    satelliteDisconnected: langGetter({
      es: "Satellite desconectado",
      en: "Satellite disconnected",
      pt: "Satellite desconectado",
    }),
    satelliteAuthorizeError: langGetter({
      es: "Error al autorizar",
      en: "Error authorizing",
      pt: "Erro ao autorizar",
    }),
    satelliteSuspendError: langGetter({
      es: "Error al suspender",
      en: "Error suspending",
      pt: "Erro ao suspender",
    }),
    satelliteReactivateError: langGetter({
      es: "Error al reactivar",
      en: "Error reactivating",
      pt: "Erro ao reativar",
    }),
    satelliteRevokeError: langGetter({
      es: "Error al revocar",
      en: "Error revoking",
      pt: "Erro ao revogar",
    }),
    satelliteToggleError: langGetter({
      es: "Error al cambiar estado",
      en: "Error changing state",
      pt: "Erro ao alterar estado",
    }),
    satelliteRotateTokenError: langGetter({
      es: "Error al rotar token",
      en: "Error rotating token",
      pt: "Erro ao rotacionar token",
    }),
    satelliteDisconnectError: langGetter({
      es: "Error al desconectar",
      en: "Error disconnecting",
      pt: "Erro ao desconectar",
    }),
  };
}
